import { render } from "./StudentCustomColumnEditTableItem.vue?vue&type=template&id=71235996&scoped=true&ts=true"
import script from "./StudentCustomColumnEditTableItem.vue?vue&type=script&lang=ts"
export * from "./StudentCustomColumnEditTableItem.vue?vue&type=script&lang=ts"

import "./StudentCustomColumnEditTableItem.vue?vue&type=style&index=0&id=71235996&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71235996"]])

export default __exports__